import { component } from 'picoapp'
import Cookies from 'js-cookie'
import '@/lib/jquery-global.js';

export default component((node, ctx) => {

    const close_modal = node.querySelector('.js-close-modal')

    if (Cookies.get('modal')) {

    } else {
        jQuery(node).fadeIn();
    }

    close_modal.addEventListener('click', () => {
        jQuery(node).fadeOut();
        Cookies.set('modal', 'hide');
    })

})